export class MessageEntry {

	// All the possible class choices, based on message level.  This determines the color of the box the messageEntrys is displayed in.
	classes = [ 'alert alert-primary', 'alert alert-info', 'alert alert-success', 'alert alert-warning', 'alert alert-danger' ];

	message:    string = '';
	level:      number = 1;
	linkText:   string = null;
	link:       string = null;

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

	alertClass() {
		return this.classes[ this.level ];
	}

}



// WEBPACK FOOTER //
// ./src/app/services/message/message-entry.ts